import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardBody,
  Input,
  Spinner,
  Label,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import parentsModal from "models/parents.modal";
import { helper } from "lib/helper";
import AttParentDetails from "./AttParentDetails";
import TutorsReplaceSummery from "./TutorsReplaceSummery";
import AttendanceSummary from "./AttendanceSummary";
import AttendanceModel from "models/Attendance.modal";
const AttendanceProfile = () => {
  const [activeTab, setActiveTab] = useState("Basicdetails");
  const [AllClass, setAllClass] = useState();
  const navigation = useNavigate();

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const getTabContentStyle = (tabId) => {
    return {
      display: activeTab === tabId ? "block" : "none",
      transition: "height 0.3s ease-in-out",
      overflow: "hidden",
    };
  };

  const [dataList, setDataList] = useState([]);
  const location = useLocation();
  const params = useParams();

  const getListData = async () => {
    // setIsLoading(true);
    // await parentsModal
    //   .listbyParentid(params?.id)
    //   .then((result) => {
    //     // setIsLoading(false);
    //     if (result) {
    //       setDataList(result?.data?.data);
    //     }
    //   })
    //   .catch((error) => {
    //     // helper.sweetalert.toast(error?.response?.data?.message, "warning");
    //   });
    const dummyData = [
      {
        id: 1,
        first_name: "John",
        last_name: "Doe",
        email: "john@example.com",
        phone: "1234567890",
      },
      {
        id: 2,
        first_name: "Jane",
        last_name: "Smith",
        email: "jane@example.com",
        phone: "0987654321",
      },
    ];
    setDataList(dummyData);
  };
  const GetAllCycle = async () => {
    // await AttendanceModel.GetAllCycle(params?.id)
    //   .then((result) => {
    //     if (result) {
    //       setAllClass(result);
    //       console.log(result, "resultresult");
    //     }
    //   })
    //   .catch((error) => {});
    const dummyCycles = {
      data: {
        data: [
          {
            id: 1,
            name: "Cycle 1",
            start_date: "2023-01-01",
            end_date: "2023-06-01",
          },
          {
            id: 2,
            name: "Cycle 2",
            start_date: "2023-07-01",
            end_date: "2023-12-01",
          },
        ],
      },
    };
    setAllClass(dummyCycles);
  };

  const [selectedCycle, setSelectedCycle] = useState("");

  const handleSelectChange = async (e) => {
    const selectedCycleNumber = e.target.value;
    await GetAllAttendance(selectedCycleNumber);
  };
  const GetAllAttendance = async (cycleNumber) => {
    // await AttendanceModel.GetAllAttendanceList(params?.id, cycleNumber)
    //   .then((result) => {
    //     if (result) {
    //       setAllClass(result);
    //       console.log(result, "resultresult");
    //     }
    //   })
    //   .catch((error) => {
    //     // helper.sweetalert.toast(error.response?.data?.message, "warning");
    //   });
    const dummyAttendance = {
      data: {
        data: [
          { id: 1, date: "2023-10-01", status: "Present", student_id: 1 },
          { id: 2, date: "2023-10-02", status: "Absent", student_id: 1 },
          { id: 3, date: "2023-10-01", status: "Present", student_id: 2 },
        ],
      },
    };
    setAllClass(dummyAttendance);
  };
  useEffect(() => {
    getListData();
    GetAllCycle();
  }, [location, params?.id]);

  const parmas = useParams();
  const [studentList, setStudentList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const GetAllStudentbyParentid = () => {
    // setIsLoading(true);
    // parentsModal
    //   .listbyParentidStudentGet(parmas?.parentid)
    //   .then((response) => {
    //     console.log(response);
    //     setStudentList(response.data.data);
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     // console.log(error);
    //     setIsLoading(false);
    //   });
    const dummyStudents = [
      { id: 1, name: "Alice Student", grade: "10th" },
      { id: 2, name: "Bob Student", grade: "9th" },
    ];
    setStudentList(dummyStudents);
    setIsLoading(false);
  };
  useEffect(() => {
    if (parmas.id != "") {
      GetAllStudentbyParentid();
    }
  }, []);

  const [selectedStudentId, setSelectedStudentId] = useState("");

  const handleSelectChangeStudent = (e) => {
    const selectedId = e.target.value;
    setSelectedStudentId(selectedId);
    // You can also perform any other actions needed with the selected ID
  };

  const [selectedCycleId, setSelectedCycleid] = useState("");

  useEffect(() => {
    if (AllClass?.data?.data?.length > 0) {
      setSelectedCycleid(AllClass?.data?.data[0]?.id);
    }
  }, [AllClass]);

  const handleSelectChangeCycle = (e) => {
    const selectedId = e.target.value;
    setSelectedCycleid(selectedId);
  };

  console.log(selectedCycleId, "selectedCycleId");

  const [ClassData, setClassData] = useState([]);

  const GetClassDataByid = async () => {
    // setIsLoading(true);
    // await AttendanceModel.GetClassById(params?.id)
    //   .then((result) => {
    //     setIsLoading(false);
    //     if (result) {
    //       setClassData(result?.data?.data);
    //     }
    //   })
    //   .catch((error) => {
    //     // helper.sweetalert.toast(error.response?.data?.message, "warning");
    //   });
    const dummyClassData = [
      {
        id: 1,
        name: "Math Class",
        tutor: "John Tutor",
        subject: "Mathematics",
        schedule: "Mon-Wed-Fri 10:00 AM",
      },
    ];
    setClassData(dummyClassData);
    setIsLoading(false);
  };
  useEffect(() => {
    GetClassDataByid();
  }, [location, params?.id]);

  const [cycledata, setCycledata] = useState();
  const GetAllCycles = async () => {
    // AttendanceModel.getcycle(params?.id)
    //   .then((responce) => {
    //     setCycledata(responce?.data?.data);
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //   });
    const dummyCycleData = [
      {
        id: 1,
        cycle_name: "Fall 2023",
        start_date: "2023-09-01",
        end_date: "2023-12-01",
      },
      {
        id: 2,
        cycle_name: "Spring 2024",
        start_date: "2024-01-01",
        end_date: "2024-04-01",
      },
    ];
    setCycledata(dummyCycleData);
  };
  useEffect(() => {
    if (params?.id) {
      GetAllCycles();
    }
  }, [location]);
  useEffect(() => {
    const scrollToHash = (retryCount = 0) => {
      if (location.hash) {
        const targetId = location.hash.replace("#", "");
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Smooth scroll to the element
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (retryCount < 10) {
          // Retry after a short delay if the element isn't found
          setTimeout(() => scrollToHash(retryCount + 1), 100);
        }
      }
    };

    // Delay the initial call slightly to account for rendering time
    setTimeout(() => scrollToHash(), 100);
  }, [location.hash]);

  return (
    <>
      {params?.id !== "undefined" && (
        <>
          <Container className="px-4 py-7">
            <Row>
              <div className="col"></div>
            </Row>
            <Card className="shadow">
              <CardBody>
                <div className={`${isLoading ? "" : "d-none"}`}>
                  <Spinner>Loading</Spinner>
                </div>
                <div className={`container ${isLoading ? "d-none" : ""}`}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Input
                      id="forType"
                      type="select"
                      style={{ width: "20%", marginLeft: "20px" }}
                      size="sm"
                      className="mr-3 "
                      onChange={handleSelectChangeStudent}
                      value={selectedStudentId}
                    >
                      {studentList &&
                        studentList?.map((item, index) => {
                          return (
                            <option value={item.id} key={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                    </Input>

                    <div>
                      <Label
                        style={{
                          fontSize: "14px",
                        }}
                      >
                        Cycle
                      </Label>
                      <select
                        className="px-4 ml-2  rounded py-1"
                        style={{ borderColor: "lightgray" }}
                        defaultValue={params?.mid}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          if (params?.id && selectedValue) {
                            navigation(
                              `/admin/creditmapping/creditmapping-view/${params.id}/${selectedValue}`
                            );
                          }
                        }}
                      >
                        {cycledata?.map((item, index) => {
                          return <option value={item?.id}>{index + 1}</option>;
                        })}
                      </select>
                    </div>
                  </div>

                  {/* <div > */}
                  <div
                    className="col-12  px-0"
                    id="v-pills-tabContent"
                    style={{}}
                  >
                    {/* <div style={getTabContentStyle("Parentdetails")}>
                <CardBody>
                  <AttParentDetails />
                </CardBody>
              </div>
              <div style={getTabContentStyle("TutorsReplaceSummery")}>
                <CardBody>
                  <TutorsReplaceSummery />
                </CardBody>
              </div>
              <div style={getTabContentStyle("AttendanceSummery")}>
                <CardBody>
                  <AttendanceSummary />
                </CardBody>
              </div> */}
                    <div className="mt-2">
                      <AttParentDetails />
                    </div>
                    <div className="mt-2">
                      <AttendanceSummary
                        CycleId={selectedCycleId}
                        ClassData={ClassData}
                      />
                    </div>
                    <div className="mt-2">
                      <TutorsReplaceSummery ClassData={ClassData} />
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </CardBody>
            </Card>
          </Container>
        </>
      )}
      {params?.id == "undefined" && (
        <Container className="px-4 py-7">
          <Card>
            <CardBody>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <spna>
                  <i
                    class="fa-solid fa-triangle-exclamation"
                    style={{
                      color: "red",
                      fontSize: "20px",
                      marginRight: "5px",
                    }}
                  ></i>
                </spna>
                <span>Attendence Id not found</span>
              </div>
            </CardBody>
          </Card>
        </Container>
      )}
    </>
  );
};

export default AttendanceProfile;
